// src/pages/FacturacionPresupuestos/ModalGuardadoExitoso.js
import React, { useState, useEffect } from 'react';
import { FaCheckCircle, FaClock, FaTimes, FaFileAlt } from 'react-icons/fa';

const ModalGuardadoExitoso = ({
    isOpen,
    onClose,
    detalles = {},
    tiempoSegundos = 6
}) => {
    const [segundosRestantes, setSegundosRestantes] = useState(tiempoSegundos);

    useEffect(() => {
        if (!isOpen) return;

        setSegundosRestantes(tiempoSegundos);

        const timer = setInterval(() => {
            setSegundosRestantes((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    onClose();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [isOpen, tiempoSegundos, onClose]);

    if (!isOpen) return null;

    const tipoNombre = detalles.tipo === 'presupuesto' ? 'Presupuesto Formal' :
                       detalles.tipo === 'pago' ? 'Nota de Pago' : 'Remisión de Cobro';

    return (
        <div 
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(15, 23, 42, 0.65)',
                backdropFilter: 'blur(4px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10000,
                padding: '16px'
            }}
            onClick={onClose}
        >
            <div 
                style={{
                    background: '#ffffff',
                    borderRadius: '16px',
                    boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05)',
                    maxWidth: '440px',
                    width: '100%',
                    padding: '28px 24px',
                    textAlign: 'center',
                    position: 'relative',
                    animation: 'modalSlideIn 0.25s cubic-bezier(0.16, 1, 0.3, 1)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Botón Cerrar X */}
                <button
                    type="button"
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '14px',
                        right: '14px',
                        background: 'transparent',
                        border: 'none',
                        color: '#94a3b8',
                        cursor: 'pointer',
                        fontSize: '16px',
                        padding: '4px'
                    }}
                    title="Cerrar"
                >
                    <FaTimes />
                </button>

                {/* Icono de Éxito Zen */}
                <div 
                    style={{
                        width: '68px',
                        height: '68px',
                        borderRadius: '50%',
                        backgroundColor: '#dcfce7',
                        color: '#16a34a',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '36px',
                        margin: '0 auto 16px auto',
                        boxShadow: '0 0 0 8px #f0fdf4'
                    }}
                >
                    <FaCheckCircle />
                </div>

                {/* Título */}
                <h3 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: 800, color: '#0f172a' }}>
                    ¡Guardado Exitosamente!
                </h3>
                <p style={{ margin: '0 0 18px 0', fontSize: '13px', color: '#64748b' }}>
                    Los datos del documento y sus partidas han quedado registrados en la plataforma.
                </p>

                {/* Detalles del Documento */}
                <div 
                    style={{
                        background: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        borderRadius: '10px',
                        padding: '12px 16px',
                        marginBottom: '18px',
                        textAlign: 'left',
                        fontSize: '13px'
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                        <span style={{ color: '#64748b', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <FaFileAlt style={{ color: '#0284c7' }} /> Documento:
                        </span>
                        <strong style={{ color: '#0f172a' }}>{tipoNombre}</strong>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                        <span style={{ color: '#64748b' }}>Folio Oficial:</span>
                        <strong style={{ color: '#1e3a8a', fontFamily: 'monospace', fontSize: '14px' }}>{detalles.folio || 'S/F'}</strong>
                    </div>
                    {detalles.cliente && (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ color: '#64748b' }}>Cliente / Destinatario:</span>
                            <strong style={{ color: '#0f172a', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {detalles.cliente}
                            </strong>
                        </div>
                    )}
                </div>

                {/* Reloj y Cuenta Regresiva */}
                <div 
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        background: '#f1f5f9',
                        color: '#475569',
                        padding: '6px 14px',
                        borderRadius: '20px',
                        fontSize: '12px',
                        fontWeight: 600,
                        marginBottom: '20px'
                    }}
                >
                    <FaClock style={{ color: '#0284c7' }} />
                    <span>Cerrando automáticamente en <strong>{segundosRestantes}</strong> {segundosRestantes === 1 ? 'segundo' : 'segundos'}...</span>
                </div>

                {/* Botón Aceptar */}
                <div>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{
                            width: '100%',
                            background: '#16a34a',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '12px 20px',
                            fontSize: '14px',
                            fontWeight: 700,
                            cursor: 'pointer',
                            transition: 'all 0.15s ease',
                            boxShadow: '0 4px 12px rgba(22, 163, 74, 0.25)'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#15803d'}
                        onMouseLeave={(e) => e.currentTarget.style.background = '#16a34a'}
                    >
                        Aceptar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalGuardadoExitoso;
